import React, { useState } from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  Box,
  ThemeProvider,
  createTheme,
  CssBaseline,
  Paper,
  Typography
} from '@mui/material';
import { Work } from '@mui/icons-material';

import comoserproveedor from '../../recursos/comoserproveedoringles.jpg'
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import PersonaInternacional from '../Formularios/personaInternacional';
import Container from '@mui/material/Container';
import { useNavigate } from 'react-router-dom';
import { encrypt, decrypt, getIDWorkmanagerRegistroProveedoresInternacional } from '../FunctionLogin'

// --- Premium Theme Definition ---
const theme = createTheme({
  palette: {
    primary: {
      main: '#BD1F34', // Talsa Red
      dark: '#8a1525',
      light: '#e04f5f',
    },
    text: {
      primary: '#2D3436',
      secondary: '#636E72',
    },
    background: {
      default: '#F0F2F5',
      paper: '#FFFFFF',
    },
  },
  typography: {
    fontFamily: '"Outfit", "Roboto", "Helvetica", "Arial", sans-serif',
    h5: {
      fontWeight: 700,
      color: '#BD1F34',
    },
    h6: {
      fontWeight: 600,
      color: '#2D3436',
    }
  },
  shape: {
    borderRadius: 16,
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          boxShadow: '0 8px 30px rgba(0,0,0,0.08)',
          overflow: 'hidden'
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '50px',
          textTransform: 'none',
          fontWeight: 600,
          boxShadow: '0 4px 14px 0 rgba(189, 31, 52, 0.39)',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: '12px',
            backgroundColor: '#F9FAFB',
            '&:hover fieldset': { borderColor: '#BD1F34' },
            '&.Mui-focused fieldset': { borderColor: '#BD1F34' },
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          borderRadius: '12px',
          backgroundColor: '#F9FAFB',
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#BD1F34' },
        }
      }
    }
  },
});

export default function FormularioRegistros() {
  const [nitRegistro, setNitRegistro] = useState('');
  const navigate = useNavigate();
  React.useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const codigo = urlParams.get('id');
    const encodedValue = urlParams.get('id');
    if (encodedValue) {
      decrypt(decodeURIComponent(encodedValue)).then((result) => {
        if (result === "") {
          navigate("/proveedores/cerrar")
        }
        setNitRegistro(result)
        getIDWorkmanagerRegistroProveedoresInternacional(result).then((resultv2) => {
          if (resultv2.length >= 1) {
            navigate("/proveedores/cerrar")
          }
        })
      });
    }
    if (codigo === null) {
      navigate("/proveedores/cerrar")
    }
  }, [])


  const [tipoPersona, setTipoPersona] = useState('natural');
  const [solicitante, setSolicitante] = useState('');
  const [proceso, setProceso] = useState('ADMINISTRATIVO Y GESTION HUMANA');
  const [sucursal, setSucursal] = useState('ANTIOQUIA');
  const [servicio, setServicio] = useState('');
  const [tipoNegociacion, setTipoNegociacion] = useState('CONTADO');
  const [tipoNegociacion2, setTipoNegociacion2] = useState('ABASTECIMIENTO');
  const [nombreDiligenciaFormato, setNombreDiligenciaFormato] = useState('');
  const [cargoDiligenciaFormato, setCargoDiligenciaFormato] = useState('');
  const [tipoVinculacion, setTipoVinculacion] = useState('');

  const tipoVinculacionValues = [
    { label: "Registration", value: "Vinculación" },
    { label: "Update", value: "Actualización" },
  ];

  // Values not used in this form but passed to child
  const handleTipoPersonaChange = (event) => setTipoPersona(event.target.value);
  const handleSolicitanteChange = (event) => setSolicitante(event.target.value);
  const handleProcesoChange = (event) => setProceso(event.target.value);
  const handleSucursalChange = (event) => setSucursal(event.target.value);
  const handleServicioChange = (event) => setServicio(event.target.value);
  const handleTipoNegociacionChange = (event) => setTipoNegociacion(event.target.value);
  const handleTipoNegociacionChange2 = (event) => setTipoNegociacion2(event.target.value);
  const handCargoDiligenciaFormato = (event) => setCargoDiligenciaFormato(event.target.value);
  const HandMombreDiligenciaFormato = (event) => setNombreDiligenciaFormato(event.target.value);


  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={{ minHeight: '100vh', py: 4, display: 'flex', justifyContent: 'center', bgcolor: '#F0F2F5' }}>
        <Container maxWidth="md">
          <Card>
            <CardMedia
              component="img"
              sx={{ width: '100%', height: 'auto', maxHeight: { xs: 200, sm: 300, md: 400 }, objectFit: 'contain' }}
              image={comoserproveedor}
              alt="International Supplier Registration"
            />
            <CardContent sx={{ p: { xs: 3, md: 5 } }}>
              <Box sx={{ textAlign: 'center', mb: 4 }}>
                <Typography gutterBottom variant="h5" component="div">
                  International Supplier Registration
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Please complete the required information below to proceed.
                </Typography>
              </Box>

              <Box sx={{ mt: 2 }}>
                <Box sx={{ mb: 4, p: 3, bgcolor: '#FFF', borderRadius: 3, border: '1px solid #F0F0F0' }}>
                  <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Work fontSize="small" sx={{ color: '#BD1F34' }} /> Request Type
                  </Typography>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel id="tipo-vinculacion-label">Select type of request</InputLabel>
                    <Select
                      labelId="tipo-vinculacion-label"
                      required
                      value={tipoVinculacion}
                      onChange={(e) => setTipoVinculacion(e.target.value)}
                      label="Select type of request"
                    >
                      {tipoVinculacionValues.map((tipo) => (
                        <MenuItem key={tipo.value} value={tipo.value}>
                          {tipo.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>

                <PersonaInternacional
                  solicitanteValue={solicitante}
                  procesoValue={proceso}
                  sucursalValue={sucursal}
                  servicioValue={servicio}
                  tipoNegociacionValue={tipoNegociacion}
                  tipoNegociacion2Value={tipoNegociacion2}
                  idregisto={nitRegistro}
                  nombreFormato={nombreDiligenciaFormato}
                  cargoFormato={cargoDiligenciaFormato}
                  tipoPersonaRegistro={tipoPersona}
                  tipoVinculacionRegistro={tipoVinculacion}
                />
              </Box>
            </CardContent>
            <CardActions sx={{ justifyContent: 'center', pb: 3 }}>
              <Button size="small" color="secondary">Terms and Conditions</Button>
            </CardActions>
          </Card>
        </Container>
      </Box>
    </ThemeProvider>
  );
};
